import React, { Component, Fragment } from 'react';
import {
    Filter,
    SearchInput,
    ReferenceField,
    ReferenceInput,
    SelectInput,
    BooleanInput,
    useRefresh,
    useRecordContext,
    useNotify,
} from 'react-admin';
import { CircularProgress } from '@material-ui/core';
import { Tooltip } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import EditIcon from '@material-ui/icons/Edit';
import EmailIcon from '@material-ui/icons/Email';
import DraftsIcon from '@material-ui/icons/Drafts';
import { Link } from 'react-router-dom';
import { linkToRecord } from 'ra-core';
import { API_BASE_URL } from '../config.jsx';
import { CustomExport } from './CustomExport';
import LockOpenIcon from '@material-ui/icons/LockOpen';
import LockIcon from '@material-ui/icons/Lock';
import { usePermissions } from 'react-admin';
import { ROLE_ADMIN, isInRole } from '../authProvider';
import VpnKeyIcon from '@material-ui/icons/VpnKey';

const ResetPasswordButton = () => {
    const refresh = useRefresh();
    const record = useRecordContext();
    const notify = useNotify();
    const color = record.mustChangePassword ? { color: 'red' } : { color: 'green' };
    const onButtonClick = () => {
        const token = localStorage.getItem('token');
        fetch(`${API_BASE_URL}/users/ForcePasswordChange?id=${record.id}&value=true`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then(r => {
            notify(`User will be forced to reset password on next HEXSelector login`, { type: 'success' });
            refresh();
        });
    }
    const toolText = record.mustChangePassword ? 'User already has a pending password reset claim' : 'Add a password reset claim - this forces the user to change their password on next HEXSelector login';
    return <Tooltip title={toolText}><Button onClick={() => onButtonClick()}><VpnKeyIcon style={color} /></Button></Tooltip>
}

const UserFilter = (props) => {
    const { permissions } = usePermissions();
    const isAdmin = isInRole(ROLE_ADMIN, permissions);
    return (
    <Fragment>
        <Filter {...props}>
            <SearchInput source="q" alwaysOn />
            <ReferenceInput  label="Country" source="country" reference="countries">
                <SelectInput optionText="name"></SelectInput>
            </ReferenceInput>
            <BooleanInput label="Web API User" source="api"></BooleanInput>
        </Filter>
        { props.context === "button" && isAdmin ? <CustomExport endPoint="/DataExport/Users" filter={props.filterValues} filename='users'/> : null }
    </Fragment>
    );
};

const HEXSelectorButton = ({ record, source, userId='123' }) => {
    const stylePending = { color: 'orange' };
    const styleApproved = { color: 'green' };
    const styleRejected = { color: 'red' };
    let disabled = true;
    let style = {};
    if (record) {
        disabled = false;
        if (record.licenseStatus === 0) { style = stylePending; }
        if (record.licenseStatus === 1) { style = styleApproved; }
        if (record.licenseStatus === 2) { style = styleRejected; }
    }
    return <Button
        component={Link}
        to={linkToRecord('/HEXSelector/Users', record.id)}
        label='HEXSelector'
        disabled={disabled}
        size='small'
        // variant='contained'
        style={style}>
        <EditIcon />Edit
    </Button>;
};

class HEXSelectorField extends Component {
    render() {
        return (
            <Fragment>
                <ReferenceField {...this.props} label='HEXSelector' sortable={false} source="id" link={false} reference="HEXSelector/Users" allowEmpty={false}>
                    <HEXSelectorButton userId={this.props.record.id} linkToRecord={this.props.reference} />
                </ReferenceField>
            </Fragment>
        );
    }
}

const PhecalcButton = ({ record, source }) => {
    if (!record) return null;
    const stylePending = { color: 'orange' };
    const styleApproved = { color: 'green' };
    const styleRejected = { color: 'red' };
    let disabled = true;
    let style = {};
    if (record) {
        disabled = false;
        if (record.licenseStatus === 0) { style = stylePending; }
        if (record.licenseStatus === 1) { style = styleApproved; }
        if (record.licenseStatus === 2) { style = styleRejected; }
    }
    return <Button
        component={Link}
        to={linkToRecord('phecalc/users', record.id)}
        label='PHECalc'
        disabled={disabled}
        size='small'
        // variant='contained'
        style={style}>
        <EditIcon />Edit
    </Button>;
};

class PhecalcField extends Component {
    render() {
        return <ReferenceField {...this.props} label='Phecalc' sortable={false} source="id" reference="Phecalc/Users" link={false} allowEmpty={true}>
            <PhecalcButton userId={this.props.record.id} />
        </ReferenceField>;
    }
}

class StatusEmailField extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userId: props.record.id,
            fetching: false,
            hasSent: false,
        };
    }

    onButtonClick() {
        this.setState({fetching: true});
        const token = localStorage.getItem('token');
        // options.headers.set('Authorization', `Bearer ${token}`);
           fetch(`${API_BASE_URL}/HEXSelector/AccountStatusEmail/${this.state.userId}`, {
               method: 'GET',
               headers: {
                'Authorization': `Bearer ${token}`
               }
           }).then(r => {
            this.setState({fetching: false, hasSent: true});
        });
    }

    render() {
        let icon = this.state.hasSent ? <EmailIcon ></EmailIcon> : <DraftsIcon></DraftsIcon>;
        return <Tooltip title='Send an email to this user advicing them of their HEXSelector account status'>
                {this.state.fetching ? <CircularProgress  size={10} /> : <Button onClick={() => this.onButtonClick()}>{icon}</Button>}
            </Tooltip>;
            
    }
}


class UserLockoutField extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userId: props.record.userId,
            locked: props.record.lockoutEndDateUtc ? true : false,
            fetching: false,
        }
    }

    onButtonClick() {
        this.setState({fetching: true});
        const token = localStorage.getItem('token');
        // options.headers.set('Authorization', `Bearer ${token}`);
        fetch(`${API_BASE_URL}/HEXSelector/AccountStatusEmail/${this.state.userId}`, {
            method: 'GET',
            headers: {
            'Authorization': `Bearer ${token}`
            }
        }).then(r => {
            this.setState({fetching: false, hasSent: true});
        });
    }

    render() {
        let icon = this.state.locked ? <LockOpenIcon /> : <LockIcon />;
        return this.state.fetching ? <CircularProgress  size={10} /> : <Button onClick={() => this.onButtonClick()}>{icon}</Button>
    }
}

class CreateHSProfileButton extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userId: props.record.id,
            fetching: false,
        }
    }

    onButtonClick() {
        this.setState({ fetching: true });
        const token = localStorage.getItem('token');
        // options.headers.set('Authorization', `Bearer ${token}`);
        fetch(`${API_BASE_URL}/HEXSelector/Users/HSCreate/${this.state.userId}`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then(r => {
            this.setState({ fetching: false });
        }).catch(err => {
            this.setState({ fetching: false });
        });
    }
    render() {
        return (
            this.state.fetching ? <CircularProgress /> : <Button onClick={() => this.onButtonClick()}>+</Button>
        )
    }
}

const BasicButton = ({ record, source }) => {
    if (!record) return null;
    return <Button
        component={Link}
        to={linkToRecord('/users', record.id)}
        label='Basic'
        size='small'>
        <EditIcon />Edit
    </Button>;
};

export { BasicButton, PhecalcField, HEXSelectorField, UserFilter, StatusEmailField, UserLockoutField, CreateHSProfileButton, ResetPasswordButton};
